module.exports = __webpack_public_path__ + "img/vp-fullscreen.e9ffdb35.svg";